import type { FC } from "react";

import Translate from "src/ui/components/Translate/Translate";

import { IconMacroCalories } from "./MacroIcons";
import {
  CaloriesRows,
  Label,
  MacroIcon,
  MacroRows,
  Row,
  Table,
  Value
} from "./MealMacroTable.styled";
import { formatCalorieRange, formatNutrition } from "./mealInsightHelpers";
import {
  CALORIES_ICON_COLOR,
  MEAL_MACROS,
  type MealInsightNutrients
} from "./mealMacros";

const CALORIES_VALUE_COLOR = "var(--color-charcoal-80, rgba(33, 33, 33, 0.8))";

interface MealMacroTableProps {
  nutrients?: MealInsightNutrients;
  caloriesRange?: { from?: number; to?: number };
}

const MealMacroTable: FC<MealMacroTableProps> = ({
  nutrients,
  caloriesRange
}) => {
  const calories = formatCalorieRange(caloriesRange?.from, caloriesRange?.to);

  return (
    <Table>
      <MacroRows>
        {MEAL_MACROS.map(({ nutrient, label, color, Icon }) => (
          <Row key={nutrient}>
            <MacroIcon $color={color}>
              <Icon />
            </MacroIcon>
            <Label>
              <Translate msg={label} />
            </Label>
            <Value $color={color}>
              {formatNutrition(nutrients?.[nutrient])}
            </Value>
          </Row>
        ))}
      </MacroRows>
      <CaloriesRows>
        <Row>
          <MacroIcon $color={CALORIES_ICON_COLOR}>
            <IconMacroCalories />
          </MacroIcon>
          <Label>
            <Translate msg="mealInsights.nutrition.calories" />
          </Label>
          <Value $color={CALORIES_VALUE_COLOR}>{calories ?? "--"}</Value>
        </Row>
      </CaloriesRows>
    </Table>
  );
};

export default MealMacroTable;
